// If you're adding a custom event, add it also to customEventTypes in this file.
export var EventType;
(function (EventType) {
    /**
     * An app's menu was reordered
     *
     * @type {string}
     */
    EventType["appMenuReorder"] = "appMenuReorder";
    /**
     * An app component was deleted.
     *
     * @type {string}
     */
    EventType["componentDeleted"] = "componentDeleted";
    /**
     * A connected component's GFPP was clicked
     *
     * @type {string}
     */
    EventType["componentGfppClicked"] = "componentGfppClicked";
    /**
     * An app action was clicked
     *
     * @type {string}
     */
    EventType["appActionClicked"] = "appActionClicked";
    /**
     * A connected component was pasted.
     *
     * @type {string}
     */
    EventType["connectedComponentPasted"] = "connectedComponentPasted";
    /**
     * A connected component was duplicated.
     *
     * @type {string}
     */
    EventType["connectedComponentDuplicated"] = "connectedComponentDuplicated";
    /**
     * A change was done to the app when a settings panel of the app is open by another user
     *
     * @type {string}
     */
    EventType["concurrentPanelEdit"] = "concurrentPanelEdit";
    /**
     * A widget was pasted.
     *
     * @type {string}
     */
    EventType["widgetPasted"] = "widgetPasted";
    /**
     * A widget was duplicated.
     *
     * @type {string}
     */
    EventType["widgetDuplicated"] = "widgetDuplicated";
    /**
     * A widget was added from any flow (add, duplicate, paste).
     *
     * @type {string}
     */
    EventType["widgetAdded"] = "widgetAdded";
    /**
     * A new controller was added to the stage for this app
     *
     * @type {string}
     */
    EventType["controllerAdded"] = "controllerAdded";
    /**
     * The controller's "settings" button was clicked
     *
     * @type {string}
     */
    EventType["controllerSettingsButtonClicked"] = "controllerSettingsButtonClicked";
    /**
     * The controller's gfpp button was clicked
     *
     * @type {string}
     */
    EventType["controllerGfppClicked"] = "controllerGfppClicked";
    /**
     * A StateBox's selected state has been changed
     *
     * @type {string}
     */
    EventType["stateChanged"] = "stateChanged";
    /**
     * A StateBox's state has been added
     *
     * @type {string}
     */
    EventType["stateAdded"] = "stateAdded";
    /**
     * A StateBox's state has been duplicated
     *
     * @type {string}
     */
    EventType["stateDuplicated"] = "stateDuplicated";
    /**
     * An app's page was deleted
     *
     * @type {string}
     */
    EventType["pageDeleted"] = "pageDeleted";
    /**
     * The site was published
     *
     * @type {string}
     */
    EventType["siteWasPublished"] = "siteWasPublished";
    /**
     * The site was saved for the first time.
     *
     * @type {string}
     */
    EventType["siteWasFirstSaved"] = "siteWasFirstSaved";
    /**
     * The site was saved, first time or any time.
     *
     * @type {string}
     */
    EventType["siteWasSaved"] = "siteWasSaved";
    /**
     * The panel was loaded with the specified configuration
     *
     * @type {string}
     */
    EventType["startConfiguration"] = "startConfiguration";
    /**
     * The apps' welcome section's main action was clicked in the add panel
     *
     * @type {string}
     */
    EventType["welcomeSectionMainActionClicked"] = "welcomeSectionMainActionClicked";
    /**
     * A widget's gfpp button was clicked
     *
     * @type {string}
     */
    EventType["widgetGfppClicked"] = "widgetGfppClicked";
    /**
     * An app was upgraded successfully
     *
     * @type {string}
     */
    EventType["appUpgradeCompleted"] = "appUpgradeCompleted";
    /**
     * An app instance was changed
     *
     * @type {string}
     */
    EventType["instanceChanged"] = "instanceChanged";
    /**
     * Components selection was changed
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["componentSelectionChanged"] = "componentSelectionChanged";
    /**
     * A preset in the global design was clicked
     *
     * @type {string}
     */
    EventType["globalDesignPresetChanged"] = "globalDesignPresetChanged";
    /**
     * Developer mode was turned on or off
     *
     * @type {string}
     */
    EventType["developerModeChanged"] = "developerModeChanged";
    /**
     * Developer mode status was changed
     *
     * @type {string}
     */
    EventType["developerModeStatusChanged"] = "developerModeStatusChanged";
    /**
     * Focused page has changed. Called after navigation to page or lightbox
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["focusedPageChanged"] = "focusedPageChanged";
    /**
     * Component Added to editor stage
     *
     * @deprecated — listen to `connectedComponentAddedToStage` for notifications about
     * TPA's connected components or to `anyComponentAddedToStage` for notifications about any component
     * @type {string}
     */
    EventType["componentAddedToStage"] = "componentAddedToStage";
    /**
     * A component connected to your TPA was added to the Editor stage.
     *
     * @type {string}
     */
    EventType["connectedComponentAddedToStage"] = "connectedComponentAddedToStage";
    /**
     * A widget's preset was changed.
     *
     * @type {string}
     */
    EventType["presetChanged"] = "presetChanged";
    /**
     * Any component was added to the Editor stage
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["anyComponentAddedToStage"] = "anyComponentAddedToStage";
    /**
     * Application version was updated
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["appUpdateCompleted"] = "appUpdateCompleted";
    /**
     * The app's live preview was refreshed
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["appRefreshCompleted"] = "appRefreshCompleted";
    /**
     * Component animation was changed
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["componentAnimationChanged"] = "componentAnimationChanged";
    /**
     * Component data was changed
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["componentDataChanged"] = "componentDataChanged";
    /**
     * Component design was changed
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["componentDesignChanged"] = "componentDesignChanged";
    /**
     * Component design was changed
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["componentStyleChanged"] = "componentStyleChanged";
    /**
     * Editor switched back from preview
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["switchedFromPreview"] = "switchedFromPreview";
    /**
     * Component arrangement was changed (z-index)
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["componentArrangementChanged"] = "componentArrangementChanged";
    /**
     * Component drag ended
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["componentDragEnded"] = "componentDragEnded";
    /**
     * Component resize started
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["componentResizeStarted"] = "componentResizeStarted";
    /**
     * Component rotate ended
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["componentRotateEnded"] = "componentRotateEnded";
    /**
     * Site published success dialog was closed
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["sitePublishedDialogClosed"] = "sitePublishedDialogClosed";
    /**
     * page background was changed
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["pageBackgroundChanged"] = "pageBackgroundChanged";
    /**
     * Component text scale was changed in mobile
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["mobileTextScaleChanged"] = "mobileTextScaleChanged";
    /**
     * Component crop was saved
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["componentCropSaved"] = "componentCropSaved";
    /**
     * Mobile back-to-top button was toggled on
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["toggleBackToTopButtonOn"] = "toggleBackToTopButtonOn";
    /**
     * Component behavior was changed
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["componentBehaviorChanged"] = "componentBehaviorChanged";
    /**
     * Component properties data was changed
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["componentPropsChanged"] = "componentPropsChanged";
    /**
     * Switched to mobile editor (relevant only for Wix Editor)
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["switchedToMobileView"] = "switchedToMobileView";
    /**
     * Switched to desktop editor (relevant only for Wix Editor)
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["switchedToDesktopView"] = "switchedToDesktopView";
    /**
     * Text settings panel was closed
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["textEditBoxClosed"] = "textEditBoxClosed";
    /**
     * Hide element from mobile
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["hideMobileElement"] = "hideMobileElement";
    /**
     * Show hidden element in mobile
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["showMobileElement"] = "showMobileElement";
    /**
     * Page has been renamed
     * Applications that manage their pages directly, or with a router, will both be notified of this event.
     *
     * @type {string}
     */
    EventType["pageRenamed"] = "pageRenamed";
    /**
     * User clicked button on popup that recommends using dynamic pages.
     * Use this event to notify the data-binding application to begin the dynamic pages workflow.
     *
     * @type {string}
     */
    EventType["addDynamicPageClicked"] = "addDynamicPageClicked";
    /**
     * The consent policy was changed.
     *
     * @type {string}
     */
    EventType["consentPolicyChanged"] = "consentPolicyChanged";
    /**
     * A page or lightbox was duplicated.
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addEventListener).
     *
     * @type {string}
     */
    EventType["pageDuplicated"] = "pageDuplicated";
    /**
     * A page or lightbox was added.
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addEventListener).
     *
     * @type {string}
     */
    EventType["pageAdded"] = "pageAdded";
    /**
     * A user performed an undo action. This event is non-specific. For example, if a user deletes a component, a [componentDeleted](#componentDeleted) event is triggered. If the user performs an undo, you receive the *undo* event, not a component added event.
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addEventListener).
     *
     * @type {string}
     */
    EventType["undo"] = "undo";
    /**
     * A user performed a redo action. This event is non-specific. For example, if a user deletes a component, a [componentDeleted](#componentDeleted) event is triggered. If the user performs an undo and then a redo, you receive the *undo* and *redo* events, not events related to the addition and deletion of the component.
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addEventListener).
     *
     * @type {string}
     */
    EventType["redo"] = "redo";
    /**
     * Add Elements panel - Add Component clicked
     *
     * @type {string}
     */
    EventType["addElementsCompClicked"] = "addElementsCompClicked";
    /**
     * Add Elements panel - Add All Components button clicked
     *
     * @type {string}
     */
    EventType["addElementsAllCompsClicked"] = "addElementsAllCompsClicked";
    /**
     * Add Elements panel - Snap To Latest Version button clicked
     *
     * @type {string}
     */
    EventType["addElementsResetClicked"] = "addElementsResetClicked";
    /**
     * User visited the app listing in the dashboard panel. This event is triggered after the dashboard is closed in order to let the applications refresh the visited apps.
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["appVisitedInDashboard"] = "appVisitedInDashboard";
    /**
     * Component was added to the app's container (AppWidget)
     *
     * @type {string}
     */
    EventType["componentAddedToApp"] = "componentAddedToApp";
    /**
     * An error occurred during a document services operation.
     *
     * @type {string}
     */
    EventType["documentOperationError"] = "documentOperationError";
    /**
     * An event for handling limitation when trying to add widget.
     *
     * @type {string}
     */
    EventType["solveAddWidgetLimitation"] = "solveAddWidgetLimitation";
    /**
     * A component was connected to a controller.
     *
     * @type {string}
     */
    EventType["componentConnected"] = "componentConnected";
    /**
     * A component was disconnected from a controller.
     *
     * @type {string}
     */
    EventType["componentDisconnected"] = "componentDisconnected";
    /**
     * A panel header button was clicked.
     *
     * @type {string}
     */
    EventType["panelHeaderButtonClicked"] = "panelHeaderButtonClicked";
    /**
     * Site theme was changed.
     *
     * @type {string}
     */
    EventType["themeChanged"] = "themeChanged";
    /**
     * View state of a widget was changed.
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["viewStateChanged"] = "viewStateChanged";
    /**
     * The app's permissions were revoked following an undo/redo process.
     * @type {string}
     */
    EventType["revokeApp"] = "revokeApp";
    /**
     * The app's permissions were granted following an undo/redo process.
     * @type {string}
     */
    EventType["grantApp"] = "grantApp";
    /**
     * An app's page variant was selected
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addeventlistener).
     *
     * @type {string}
     */
    EventType["pageVariantSelected"] = "pageVariantSelected";
    /**
     * A widget's overrides were reset
     *
     * @type {string}
     */
    EventType["resetWidgetOverrides"] = "resetWidgetOverrides";
    /**
     * Widget plugin was added
     *
     * @type {string}
     */
    EventType["widgetPluginAdded"] = "widgetPluginAdded";
    /**
     * Widget plugin was removed
     * @type {string}
     */
    EventType["widgetPluginRemoved"] = "widgetPluginRemoved";
    /**
     * Widget plugin was shown on page
     *
     * @type {string}
     */
    EventType["widgetPluginShowOnPageClicked"] = "widgetPluginShowOnPageClicked";
    /**
     * @internal
     * The app was installed
     * @type {string}
     */
    EventType["appInstalled"] = "appInstalled";
    /**
     * @internal
     * The app was removed
     * @type {string}
     */
    EventType["removeAppCompleted"] = "removeAppCompleted";
    /**
     * Site language was changed
     * To be notified on this event, add an event listener using [addEventListener](../../Editor/EventTarget.md#addEventListener).
     *
     * @type {string}
     */
    EventType["siteLanguageChanged"] = "siteLanguageChanged";
})(EventType || (EventType = {}));
/**
 * @hidden
 * The lists below help you differentiate between custom & general events for the SDK testkit.
 * As of now there is no proper way to split the enum of events into 2 separate enums and keep the usage the same as before.
 * EventInterfaces uses enum’s values in dot notation so converting enum into js object (const EventType = {...CustomEventType, ...GeneralEventType})
 * would not work in the same way (EventType.someEvent -> EventType[‘someEvent’] to access type of the property), which would be a breaking change.
 */
/**
 * Custom events list
 */
export const customEventTypes = [
    EventType.componentSelectionChanged,
    EventType.focusedPageChanged,
    EventType.anyComponentAddedToStage,
    EventType.appUpdateCompleted,
    EventType.componentAnimationChanged,
    EventType.componentDataChanged,
    EventType.componentDesignChanged,
    EventType.componentStyleChanged,
    EventType.switchedFromPreview,
    EventType.componentArrangementChanged,
    EventType.componentDragEnded,
    EventType.componentResizeStarted,
    EventType.componentRotateEnded,
    EventType.sitePublishedDialogClosed,
    EventType.pageBackgroundChanged,
    EventType.mobileTextScaleChanged,
    EventType.componentCropSaved,
    EventType.toggleBackToTopButtonOn,
    EventType.componentBehaviorChanged,
    EventType.appRefreshCompleted,
    EventType.componentPropsChanged,
    EventType.switchedToMobileView,
    EventType.switchedToDesktopView,
    EventType.textEditBoxClosed,
    EventType.hideMobileElement,
    EventType.showMobileElement,
    EventType.undo,
    EventType.redo,
    EventType.appVisitedInDashboard,
    EventType.developerModeStatusChanged,
    EventType.componentConnected,
    EventType.componentDisconnected,
    EventType.solveAddWidgetLimitation,
    EventType.pageDuplicated,
    EventType.pageAdded,
    EventType.themeChanged,
    EventType.viewStateChanged,
    EventType.pageVariantSelected,
    EventType.siteLanguageChanged,
];
/**
 * General events list
 */
export const generalEventTypes = [
    EventType.appMenuReorder,
    EventType.componentDeleted,
    EventType.componentGfppClicked,
    EventType.appActionClicked,
    EventType.connectedComponentPasted,
    EventType.connectedComponentDuplicated,
    EventType.concurrentPanelEdit,
    EventType.widgetPasted,
    EventType.widgetDuplicated,
    EventType.widgetAdded,
    EventType.resetWidgetOverrides,
    EventType.widgetPluginAdded,
    EventType.widgetPluginRemoved,
    EventType.widgetPluginShowOnPageClicked,
    EventType.controllerAdded,
    EventType.controllerSettingsButtonClicked,
    EventType.controllerGfppClicked,
    EventType.presetChanged,
    EventType.stateChanged,
    EventType.stateAdded,
    EventType.stateDuplicated,
    EventType.pageDeleted,
    EventType.siteWasPublished,
    EventType.siteWasFirstSaved,
    EventType.siteWasSaved,
    EventType.startConfiguration,
    EventType.welcomeSectionMainActionClicked,
    EventType.widgetGfppClicked,
    EventType.appUpgradeCompleted,
    EventType.instanceChanged,
    EventType.globalDesignPresetChanged,
    EventType.developerModeChanged,
    EventType.connectedComponentAddedToStage,
    EventType.pageRenamed,
    EventType.addDynamicPageClicked,
    EventType.consentPolicyChanged,
    EventType.addElementsCompClicked,
    EventType.addElementsAllCompsClicked,
    EventType.addElementsResetClicked,
    EventType.componentAddedToApp,
    EventType.documentOperationError,
    EventType.panelHeaderButtonClicked,
    EventType.grantApp,
    EventType.revokeApp,
    EventType.appInstalled,
    EventType.removeAppCompleted,
];
//# sourceMappingURL=EventType.js.map